/**
 * Mobile PDP image zoom
 * --------------------------------------------------------------
 * On mobile (< 768px), clicking a product gallery image opens a
 * full-screen modal containing every gallery image stacked
 * vertically, scrolled to the image that was clicked. Mirrors the
 * theme's built-in desktop zoom (theme.js handleImageClick) but is
 * triggered by clicking the image rather than a zoom icon, and is
 * self-contained so it survives theme.js regeneration.
 *
 * Swipe-vs-click is resolved via the gallery Swiper's own allowClick
 * flag, so swiping the carousel never opens the modal.
 *
 * Reuses the theme globals window.showThemeModal / closeThemeModal
 * and the existing .theme-modal--fullscreen / .inner-scroller /
 * .zoom-image / .modal-close CSS.
 */
(function () {
  var MOBILE_MAX = 768; // matches theme.viewport.isXs()

  function isMobile() {
    return window.innerWidth < MOBILE_MAX;
  }

  function smallSrcOf(slide) {
    var img = slide.querySelector('.rimage-wrapper > img') || slide.querySelector('img');
    return img ? img.currentSrc || img.src || '' : '';
  }

  function openZoom(tappedSlide) {
    if (typeof window.showThemeModal !== 'function' || !window.jQuery) return;
    var $ = window.jQuery;

    var gallery = tappedSlide.closest('.theme-gallery');
    if (!gallery) return;

    // Collect each real (non-duplicate) gallery image once.
    var seen = {};
    var slides = Array.prototype.slice
      .call(gallery.querySelectorAll('.theme-img[data-full-size]:not(.swiper-slide-duplicate)'))
      .filter(function (el) {
        var full = el.getAttribute('data-full-size');
        if (!full || seen[full]) return false;
        seen[full] = true;
        return true;
      });
    if (!slides.length) return;

    var tappedFull = tappedSlide.getAttribute('data-full-size');
    var marked = false;

    var imageHtml = '<a href="#" data-modal-close class="modal-close">&times;</a>';
    slides.forEach(function (el) {
      var full = el.getAttribute('data-full-size');
      var small = smallSrcOf(el) || full;
      var isTapped = !marked && full === tappedFull;
      if (isTapped) marked = true;
      imageHtml +=
        '<img class="zoom-image"' +
        (isTapped ? ' id="zoom-image"' : '') +
        ' src="' + small + '" data-full-size="' + full + '"/>';
    });

    var modalHtml =
      '<div class="theme-modal theme-modal--fullscreen temp -light" role="dialog" aria-modal="true">' +
      "<div class='inner-scroller -out'>" + imageHtml + '</div>' +
      '</div>';

    window.showThemeModal(modalHtml, 'product-image', function ($modal) {
      var $main = $('#zoom-image');
      if ($main.length) $main.attr('src', $main.data('full-size'));

      // Swap every image up to full resolution.
      setTimeout(function () {
        $modal.find('[data-full-size]').each(function () {
          this.setAttribute('src', this.getAttribute('data-full-size'));
        });
      }, 100);

      // Start the modal scrolled to the tapped image, then reveal.
      setTimeout(function () {
        if ($main.length) {
          $modal.scrollTop($main.position().top + ($main.outerHeight() / 2 - $modal.outerHeight() / 2));
        }
        $modal.find('.inner-scroller').removeClass('-out');
      }, 300);
    });

    // A double-click fires a second click ~150ms later. While the modal's
    // images are still fading in (.inner-scroller.-out is visibility:hidden,
    // so not hit-testable), that second click falls through to the theme's
    // "click outside to close" handler and instantly dismisses the modal —
    // a white flash. Swallow a single click within the double-click window
    // so the freshly-opened modal stays put. Genuine close clicks afterwards
    // are unaffected.
    var swallowNextClick = function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      document.removeEventListener('click', swallowNextClick, true);
    };
    document.addEventListener('click', swallowNextClick, true);
    setTimeout(function () {
      document.removeEventListener('click', swallowNextClick, true);
    }, 350);
  }

  // Click handler that distinguishes a real click from a carousel swipe.
  //
  // The gallery Swiper runs with preventClicks:false, so a click DOES
  // fire at the end of a swipe. Swiper still tracks whether the gesture
  // was a tap or a drag in `swiper.allowClick` (it sets it false once a
  // drag is detected), so we consult that to ignore swipe-release clicks.
  // We listen in the capture phase so Swiper's own click-suppression
  // (preventClicksPropagation) can't stop the event from reaching us.
  function bindGallery(gallery) {
    gallery.addEventListener('click', function (e) {
      if (!isMobile()) return;
      if (document.body.classList.contains('modal-active')) return;

      var slide = e.target.closest && e.target.closest('.theme-img[data-full-size]');
      if (!slide) return;

      // If Swiper saw this gesture as a drag, ignore the click.
      var sw = gallery.querySelector('.theme-viewport.swiper-container');
      sw = sw && sw.swiper;
      if (sw && sw.allowClick === false) return;

      openZoom(slide);
    }, { capture: true });
  }

  function init() {
    var galleries = document.querySelectorAll('.theme-gallery');
    for (var i = 0; i < galleries.length; i++) {
      bindGallery(galleries[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
